module.exports = __webpack_public_path__ + "static/media/YF45_4.805db80d.jpg";